export default __webpack_public_path__ + "static/media/poweredBy.272a310a.png";